import { render } from "./ObjSetTable.vue?vue&type=template&id=031b93fa"
import script from "./ObjSetTable.vue?vue&type=script&lang=js"
export * from "./ObjSetTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__